import React from 'react';

const Switcher = ({ isOn, onToggle }) => {
  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        checked={isOn}
        onChange={(e) => onToggle(e.target.checked)}
        className="sr-only peer"
      />
      <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:bg-secondary transition-all"></div>
      <div
        className={`absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform ${
          isOn ? 'translate-x-5' : ''
        }`}
      ></div>
    </label>
  );
};

export default Switcher;
